/**
 * @generated SignedSource<<f4d0f015ba29dd675eedd7dabc30fb37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IncludedLabels_displayPrice$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_displayPrice">;
  readonly " $fragmentType": "IncludedLabels_displayPrice";
}>;
export type IncludedLabels_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: IncludedLabels_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "IncludedLabels_displayPrice",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_displayPrice"
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "90a9459665e5f8eccdffae287ff928be";

export default node;
